import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { Map } from "ol";
import { EventsKey } from "ol/events";
import { unByKey } from "ol/Observable";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  readMapSettings,
  updateMapSettings,
} from "../../functions/localMapSettings";
import { CustomMapEventTypes } from "../../types/map";

interface Props {
  map?: Map;
}

export const SeaSurveyExtraSettings = ({ map }: Props): JSX.Element => {
  const { t } = useTranslation("seasurvey-layer-settings");
  const [settingsChanged, setSettingsChanged] = React.useState(false);
  const [showOutlines, setShowOutlines] = React.useState(
    readMapSettings("surveyOutlines"),
  );

  React.useEffect(() => {
    let key: EventsKey | EventsKey[];
    if (map) {
      key = map.on(CustomMapEventTypes.SettingsChanged, () =>
        setSettingsChanged((prev) => !prev),
      );
    }
    return () => {
      unByKey(key);
    };
  }, [map]);

  React.useEffect(() => {
    setShowOutlines(readMapSettings("surveyOutlines"));
  }, [settingsChanged]);

  const udpateMap = () => {
    map?.dispatchEvent(CustomMapEventTypes.SettingsChanged);
  };

  return (
    <Grid item>
      <FormControlLabel
        control={
          <Checkbox
            checked={showOutlines ?? false}
            onChange={(_e, v) => {
              updateMapSettings({ surveyOutlines: v });
              udpateMap();
            }}
          />
        }
        label={t("show-outlines")}
      />
    </Grid>
  );
};
